const YOUTUBE_ID_REGEX =
  /(?:youtube\.com\/(?:[^/\n\s]+\/.+\/|(?:v|embed|shorts|watch|oembed)(?:\/|\?v=))|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
const YOUTUBE_ID_ONLY_REGEX = /^[a-zA-Z0-9_-]{11}$/;

export const extractYoutubeVideoId = value => {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return null;
  }

  if (YOUTUBE_ID_ONLY_REGEX.test(trimmedValue)) {
    return trimmedValue;
  }

  const match = trimmedValue.match(YOUTUBE_ID_REGEX);
  return match ? match[1] : null;
};

export const buildYoutubeEmbedUrl = (videoId, queryParams = {}) => {
  if (!extractYoutubeVideoId(videoId)) {
    return null;
  }

  const searchParams = new URLSearchParams(queryParams);
  const queryString = searchParams.toString();
  return `https://www.youtube-nocookie.com/embed/${videoId}${queryString ? `?${queryString}` : ''}`;
};
